// extracted by mini-css-extract-plugin
export default {"wrapper":"CampaignSuccess--wrapper--09e734"};